module.exports = __webpack_public_path__ + "assets/img/8.d2d101d5.png";